import { render } from "./StartPlan.vue?vue&type=template&id=ae4be7b4&scoped=true"
import script from "./StartPlan.vue?vue&type=script&lang=js"
export * from "./StartPlan.vue?vue&type=script&lang=js"

import "./StartPlan.vue?vue&type=style&index=0&id=ae4be7b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae4be7b4"]])

export default __exports__